import _ from 'lodash';
import i18n from '../../i18n';

/** ************************************** Validations *************************************** */

export const required = value => (value || value === 0 ? undefined : i18n.t('validations.required'));
export const fileRequired = value => (_.get(value, 'fileName', '') !== '' ? undefined : i18n.t('validations.required'));
export const hexadecimal = value => ((/^#[0-9A-F]{6}$/i).test(value) ? undefined : i18n.t('form.validation.hexadecimal'));
export const minValue = min => value => (min <= value ? undefined : i18n.t('form.validation.minValue', { min }));
export const maxValue = max => value => (value <= max ? undefined : i18n.t('form.validation.maxValue', { max }));
export const minLength = min => value => (!value || min < value.length ? undefined : i18n.t('form.validation.minLength', { min }));
export const maxLength = max => value => (!value || value.length < max ? undefined : i18n.t('form.validation.maxLength', { max }));

/** ************************************** Restrictions ************************************** */

export const convertToNumeric = (value, canBeFloat = false) => {

    if (value) {

        let result = canBeFloat ? value.replace(/[^0-9.-]/g, '') : value.replace(/[^0-9-]/g, '');

        if (result.split('.').length > 2 || result.split('-').length > 2) {

            result = result.substring(0, result.length - 1);

        }

        return result;

    }

    return '';

};

export const trimString = value => {

    if (value) {

        const result = value.replace(/\s/g, '');

        return result;

    }

    return '';

};